import React from 'react';
import classNames from 'classnames';
import './index.scss';

interface CommonIframeProps {
  className?: string;
  style?: React.CSSProperties;
  // iframe url
  url: string;
  onLoad?: React.ReactEventHandler<HTMLIFrameElement>;
  onError?: React.ReactEventHandler<HTMLIFrameElement>;
}

const iFrameRender: React.FC<CommonIframeProps> = (props) => {
  const { className, style, url, onLoad, onError } = props || {};

  return (
    <div className={classNames('dbd-common-iframe', className)} style={style}>
      <iframe
        title="common-iframe"
        className="dbd-common-iframe-url-page"
        src={url}
        onLoad={onLoad}
        onError={onError}
      />
    </div>
  );
};

export default iFrameRender;
